import dayjs from "dayjs";
import { DurationUnitType } from "dayjs/plugin/duration";
import { Nullable } from "src/app/support/nullable";
import { DateTime } from "luxon";

let currentTimezone = "Europe/Rome";

export function dateUtilSetLocale(locale: string, localeValues?: any): void {
  dayjs.locale(locale, localeValues);
}

export function dateUtilGetTimeZone(): string {
  return currentTimezone;
}

export function dateUtilSetTimeZone(value: string): void {
  currentTimezone = value;
}

/**
 *
 * @param isoValue date in formato ISO
 * @returns Ritorna una oggetto di tipo Date con il timezone del tenant
 */
export function dateUtilToDate(isoValue: string): Date {
  return new Date(
    dayjs
      .utc(<string | Date>isoValue)
      .tz(currentTimezone)
      .toDate()
      .toLocaleString("en-US", { timeZone: currentTimezone })
  );
}

export function dateUtilDateToISOString(date: Date): string {
  return dayjs
    .tz(dayjs(date).format("YYYY-MM-DDTHH:mm:ss"), currentTimezone)
    .toISOString();
}

export function dateUtilLXAddDays(value: string, days: number) {
  return DateTime.fromISO(value).plus({ days });
}

export function dateUtil(
  value?: string | Date | Nullable<Number>,
  format?: string
): dayjs.Dayjs {
  if (value instanceof Date) {
    return dayjs.tz(
      dayjs(value).format("YYYY-MM-DDTHH:mm:ss"),
      currentTimezone
    );
  }

  if (format) {
    return dayjs.utc(<string>value, format).tz(currentTimezone);
  }

  return dayjs.utc(<string>value).tz(currentTimezone);
}

export function dateUtilIsValid(
  value: string,
  format?: string,
  strict?: boolean
): boolean {
  return dayjs(value, format, strict).isValid();
}

export function dateUtilDurationHumanize(
  value: string | number,
  unit: DurationUnitType = "milliseconds",
  withSuffix?: boolean
): string {
  return dayjs
    .duration(dateUtil().diff(dateUtil(value)), unit)
    .humanize(withSuffix);
}

export function dateUtilDiff(firstDate: string, secondDate: string): number {
  return dateUtil(firstDate).diff(dateUtil(secondDate));
}
